import script from "./software-modify-log.vue?vue&type=script&setup=true&lang=ts"
export * from "./software-modify-log.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__